import service from '@/utils/server';

const modName='/bd/weighConfirm/';
//查询方法
export const pageInfo = data => {
  return service({
    url: modName + 'pageInfo',
    method: 'post',
    data
  });
};

//称重确认
export const confirmWeighResult = data => {
  return service({
    url: modName + 'confirmWeighResult',
    method: 'post',
    data
  });
};



// WEBPACK FOOTER //
// ./src/page/bd/exceptionDeal/weighConfirm/api/index.js